import { Pipe, PipeTransform } from '@angular/core';
import { PointsTransactionService } from '@rd/core/services/points-transaction/points-transaction.service';
import { PointsStatementTransactionType } from '@rd/types';

@Pipe({
  name: 'localizePointsStatement',
  pure: true,
  standalone: false,
})
export class LocalizePointsStatementPipe implements PipeTransform {
  constructor(private pointsTransactionService: PointsTransactionService) {}

  public transform(
    amount: number,
    type: PointsStatementTransactionType,
    digitsInfo?: string,
  ): string {
    return this.pointsTransactionService.formatPointsStatementTransaction(
      amount,
      type,
      digitsInfo,
    );
  }
}
